module.exports = __webpack_public_path__ + "static/media/arrow_next.3bebaeb2.svg";